'use client';

import {
    getReviewAnswerTemplateVariableHintText,
    type ReviewAnswerTemplateVariableHintLocale,
} from '@/shared/review-answer-template-variable-hint';

type AnswerTemplateVariableHintProps = {
    locale?: ReviewAnswerTemplateVariableHintLocale | 'uz-Cyrl';
    className?: string;
    padded?: boolean;
};

const DEFAULT_HINT_CLASS_NAME = 'text-[11px] leading-4 text-slate-500';
const PADDED_HINT_CLASS_NAME = `px-1 ${DEFAULT_HINT_CLASS_NAME}`;

export const AnswerTemplateVariableHint = ({
    locale = 'ru',
    className,
    padded = false,
}: AnswerTemplateVariableHintProps) => {
    return (
        <p className={className ?? (padded ? PADDED_HINT_CLASS_NAME : DEFAULT_HINT_CLASS_NAME)}>
            {getReviewAnswerTemplateVariableHintText(locale)}
        </p>
    );
};
